import { call, takeLatest, put, } from 'redux-saga/effects';
import { getPayoutSummaryRequest, getPayoutSummarySuccess, getPayoutSummaryFailure, getPayoutHistoryRequest, getPayoutHistorySuccess, getPayoutHistoryFailure, getPayoutByOrderHistoryRequest, getPayoutByOrderHistorySuccess, getPayoutByOrderHistoryFailure, getPayoutByOrderDownloadSuccess, getPayoutByOrderDownloadFailure, getPayoutByOrderDownloadRequest } from '../actions/paymentsPageActions';
import { makePayoutSummaryCall, makePayoutHistoryCall, makePayoutByOrderHistoryCall } from '../../api/paymentsPageAPI';

export function* getPayoutSummarySaga(action) {
	try {
		const response = yield call(makePayoutSummaryCall, action);
		yield put(getPayoutSummarySuccess(response));
	} catch (e) {
		yield put(getPayoutSummaryFailure(e.message));
	}
}

export function* getPayoutHistorySaga(action) {
	try {
		const response = yield call(makePayoutHistoryCall, action);
		yield put(getPayoutHistorySuccess(response));
	} catch (e) {
		yield put(getPayoutHistoryFailure(e));
	}
}

export function* getPayoutByOrderHistorySaga(action) {
	try {
		const response = yield call(makePayoutByOrderHistoryCall, action);
		yield put(getPayoutByOrderHistorySuccess(response));
	} catch (e) {
		yield put(getPayoutByOrderHistoryFailure(e));
	}
}

export function* getPayoutByOrderDownloadSaga(action) {
	try {
		const response = yield call(makePayoutHistoryCall, action);
		yield put(getPayoutByOrderDownloadSuccess(response));
	} catch (e) {
		yield put(getPayoutByOrderDownloadFailure(e.response.data));
	}
}

 function* paymentsPageSaga() {
	yield takeLatest(getPayoutSummaryRequest, getPayoutSummarySaga);
	yield takeLatest(getPayoutHistoryRequest, getPayoutHistorySaga);
	yield takeLatest(getPayoutByOrderHistoryRequest, getPayoutByOrderHistorySaga);
	yield takeLatest(getPayoutByOrderDownloadRequest, getPayoutByOrderDownloadSaga);
}

export default paymentsPageSaga;
